import { ListFilter } from 'pages/Chat/types';

export enum ListTab {
  EU_ACTIVE = 'end_user_active',
  EU_NOT_STARTED = 'end_user_not_started',
}

export type SelectableListFilters =
  | ListFilter.UNREAD_ONLY
  | ListFilter.SCHEDULED_MESSAGES_ONLY
  | null;

export interface SelectableFilters {
  listFilter: SelectableListFilters;
  label: string;
}

export interface ChatListProps {
  title: string;
  listTab?: ListTab;
  showArrowButton?: boolean;
  showNewMessageButton?: boolean;
  onClickNewMessage?: () => void;
  onClickArrowButton?: () => void;
  onTabClick?: (listTab: ListTab) => void;
  onFilterPatients: (filterValue: string) => void;
  filterValue?: string;
  id?: string;
  hideNewMessageButton?: boolean;
  hideTipsButton?: boolean;
  selectedFilter?: SelectableListFilters;
  onSelectFilter?: (filter: SelectableListFilters) => void;
}

export const listFilterToListTab = (listFilter?: ListFilter) => {
  if (listFilter) {
    const indexOfS = Object.values(ListFilter).indexOf(listFilter);
    const key = Object.keys(ListFilter)[indexOfS] as keyof typeof ListTab;
    return ListTab[key];
  }
  return undefined;
};

export const listTabToListFilter = (listTab?: ListTab) => {
  if (listTab) {
    const indexOfS = Object.values(ListTab).indexOf(listTab);
    const key = Object.keys(ListTab)[indexOfS] as keyof typeof ListFilter;

    return ListFilter[key];
  }
  return undefined;
};
